// extracted by mini-css-extract-plugin
export default {"container":"page-number-notification-module__container--J70oi"};